import React from 'react'
import { headerChange } from 'src/main/store-models/header/header'
import { useDispatch } from 'react-redux'
import { checkApuracaoStatus } from 'src/main/usecases/generate-calculation/check-apuracao-status'
import {
  checkExportCustomerGoalStatus,
  downloadExportCustomerGoal,
} from 'src/main/usecases/customer-goals/check-export-goal-status'
import {
  checkExportCustomerGoalStDet,
  downloadExportCustomerGoalDetalhe,
} from 'src/main/usecases/customer-goals/check-export-goal-status-detalhe'
import {
  checkExportApuracaoStatus,
  downloadExportApuracao,
} from 'src/main/usecases/dashboard/check-export-apuracao-status'
import {
  checkExportStrategicProductsStatus,
  downloadExportStrategicProducts,
} from 'src/main/usecases/dashboard/check-export-strategic-products-status'

import {
  HeaderStyled, Logo, MenuHandle, RightSection,
} from './styles'
import UserWidget from '../user_widget'
import LogoImage from '../../assets/images/logo.png'
import { Icons } from '../ui/components'
import { PollingStatusIndicator } from '../polling-status-indicator'

const Header = (): JSX.Element => {
  const dispatch = useDispatch()

  return (
    <HeaderStyled>
      <MenuHandle onClick={() => dispatch(headerChange())}>
        <Icons name="RiMenuFill" />
      </MenuHandle>
      <Logo src={LogoImage} alt="LIGA CEVA" />
      <RightSection>
        <PollingStatusIndicator
          factories={[
            { id: 'gerar-apuracao', factory: (params) => () => checkApuracaoStatus(params.jobId as string) },
            {
              id: 'export-apuracao-meta',
              factory: (params) => () => checkExportApuracaoStatus(params.jobId as string),
              download: (params) => downloadExportApuracao(params.jobId as string),
            },
            {
              id: 'export-meta-cliente',
              factory: (params) => () => checkExportCustomerGoalStatus(params.jobId as string),
              download: (params) => downloadExportCustomerGoal(params.jobId as string),
            },
            {
              id: 'export-meta-cliente-detalhe',
              factory: (params) => () => checkExportCustomerGoalStDet(params.jobId as string),
              download: (params) => downloadExportCustomerGoalDetalhe(params.jobId as string),
            },
            {
              id: 'export-strategic-products',
              factory: (params) => () => checkExportStrategicProductsStatus(params.jobId as string),
              download: (params) => downloadExportStrategicProducts(params.jobId as string),
            },
          ]}
        />
        <UserWidget />
      </RightSection>
    </HeaderStyled>
  )
}

export default Header
